import { defineStore } from 'pinia'
import { ref } from 'vue'

export interface Me {
  id?: string
  user_id?: string
  first_name?: string
  last_name?: string
  email?: string
  user_image?: string
  [key: string]: unknown
}

const SERVER_ENDPOINT = (import.meta.env?.VITE_SERVER_ENDPOINT ?? '/api').replace(/\/$/, '')

export const useMeStore = defineStore('me', () => {
  const me = ref<Me | null>(null)

  const getMe = async (): Promise<Me | null> => {
    const res = await fetch(`${SERVER_ENDPOINT}/me`, { credentials: 'include' })
    if (res.status === 401 || res.status === 403) {
      window.location.href = `${SERVER_ENDPOINT}/auth/login?next=${encodeURIComponent(window.location.pathname + window.location.search)}`
      return null
    }
    if (!res.ok) throw new Error(`me failed: ${res.status}`)
    me.value = ((await res.json()) as { data: Me }).data
    return me.value
  }

  const deleteSession = () => {
    window.location.href = `${SERVER_ENDPOINT}/auth/logout`
  }

  return { me, getMe, deleteSession }
})
